export const companies = (state) => state.settings.companies;
export const jobTypes = (state) => state.settings.jobTypes;
export const connections = (state) => state.settings.connections;
export const users = (state) => state.settings.users;
export const companyConnections = (state) => state.settings.companyConnections;
export const companyConnectionConfig = (state) => state.settings.companyConnectionConfig;
